import { forestAgencyFellingBuffer } from '../../../../../api/services/ad';
import { fetchPropertyData, getProp } from '../../../../../api/services/property';

/** Backend expects `request.data.geom.geometry` (see FinalfellingApplicationGeojsonByBuffer). */
export function geomPayloadForFellingBuffer(geojson) {
  if (!geojson) return null;
  if (geojson.type === 'Feature') return geojson;
  if (geojson.geometry != null) return geojson;
  return { type: 'Feature', geometry: geojson, properties: {} };
}

/** In-flight dedupe so step 1 prefetch and step 2 load never duplicate the same ref. */
const inflightByRef = new Map();

/**
 * Fetches property sections + border/geojson, then avverkningsanmälningar for that geometry.
 * @param {string} ref Property lm ref
 */
export async function loadSellTimberMapPropertyBundle(ref) {
  const key = String(ref);
  const existing = inflightByRef.get(key);
  if (existing) return existing;

  const promise = (async () => {
    try {
      const [dataResp, getPropResp] = await Promise.all([
        fetchPropertyData(ref, 'PROP'),
        getProp(ref)
      ]);
      const data = dataResp.data;
      const propData = getPropResp.data;
      let border = null;
      if (propData?.geojson?.geometry?.coordinates) {
        border = propData.geojson.geometry.coordinates;
      }
      const propertyGeojson = propData?.geojson ?? null;
      const sections = Array.isArray(data?.sections) ? data.sections : [];

      const geom = geomPayloadForFellingBuffer(propertyGeojson);
      if (!geom) {
        return {
          ref: key,
          sections,
          borderCoords: border,
          propertyGeojson,
          fellingApplicationsGeojson: null,
          propertyFetch: { status: 'success', error: null },
          fellingFetch: {
            status: 'error',
            error: 'Saknar fastighetsgeometri för att hämta avverkningsanmälningar.'
          }
        };
      }

      const resp = await forestAgencyFellingBuffer(geom, 0);
      if (resp.ok) {
        return {
          ref: key,
          sections,
          borderCoords: border,
          propertyGeojson,
          fellingApplicationsGeojson: resp.data ?? null,
          propertyFetch: { status: 'success', error: null },
          fellingFetch: { status: 'success', error: null }
        };
      }
      return {
        ref: key,
        sections,
        borderCoords: border,
        propertyGeojson,
        fellingApplicationsGeojson: null,
        propertyFetch: { status: 'success', error: null },
        fellingFetch: { status: 'error', error: 'Kunde inte ladda avverkningsanmälningar.' }
      };
    } catch (err) {
      console.error(err);
      return {
        ref: key,
        sections: [],
        borderCoords: null,
        propertyGeojson: null,
        fellingApplicationsGeojson: null,
        propertyFetch: { status: 'error', error: 'Kunde inte ladda fastighetsdata. Försök igen senare.' },
        fellingFetch: { status: 'idle', error: null }
      };
    } finally {
      inflightByRef.delete(key);
    }
  })();

  inflightByRef.set(key, promise);
  return promise;
}
